import styled from 'styled-components'
import { P as CommonP } from '../../components/common/text'

export const P = styled(CommonP)`
  text-indent: 70px;
`
